import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'

/* 개발담당:이재호
 * 화면기능:스타일키워드 선택
 * 세부설명:
*/

export class StyleKeyword extends Component {
    static displayName = StyleKeyword.name;

    constructor(props) {
        super(props);
        this.state = {
            StyleList: [],
            GroupList: [],
            StyleKeywordModel: [],
            StyleKeywordInfo: { Sty_Cd: "", Sty_Nm: "" },
        };
        this.StyleKeywordRef = React.createRef();
        this.handleStyleSelect_Click = this.handleStyleSelect_Click.bind(this);
        this.handleClose_Click = this.handleClose_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    async InitData() {
        try {
            const Data = await Big3Common.Post('api/Goods/GoodsReg/GetStyleKeyword', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                this.setState({
                    StyleList: DataList,
                    GroupList: Big3Common.Util.groupBy(DataList, list => list.contt)
                })
            }
        }
        catch (e) {
            console.log("CallStyleKeyword", e)
        }
    }
    //스타일키워드 선택
    handleStyleSelect_Click(event, dtl_cd, dtl_nm) {
        let StyleKeywordList = this.state.StyleKeywordModel
        const check = StyleKeywordList.some(item => item.Sty_Cd === dtl_cd);
        if (StyleKeywordList.length < 6 && !check) {

            let StyleKeywordInfo = Big3Common.Util.Cloen(this.state.StyleKeywordInfo);
            StyleKeywordInfo.Sty_Cd = dtl_cd;
            StyleKeywordInfo.Sty_Nm = dtl_nm;
            StyleKeywordList.push(StyleKeywordInfo);
        }
        else {
            StyleKeywordList = StyleKeywordList.filter(item => item.Sty_Cd !== dtl_cd);
        }
        this.setState({
            StyleKeywordModel: StyleKeywordList
        })
        event.preventDefault();
    }
    //스타일키워드 등록
    handleSave_Click = async (event) => {
        const StyleKeywordModel = this.state.StyleKeywordModel;
        this.props.Callback(StyleKeywordModel);
        this.handleClose_Click(event);
    }
    handleClose_Click(event) {
        let modalID = this.props.id;
        var modalEl = document.getElementById(modalID);
        var thismodal = bootstrap.Modal.getInstance(modalEl);
        thismodal.hide();
        event.preventDefault();
    }

    Titlerender() {
        let StyleList = this.state.StyleList;
        let GroupList = this.state.GroupList;
        let SelectList = this.state.StyleKeywordModel;
        let StyleGrp = [];

        for (const item of GroupList.entries()) {
            //소재정보 리스트 세부 항목           
            let itemList = item[1];
            //클릭한 소재정보
            let SelectState = [];
            //소재정보에서 선택된 값이 있으면 설정
            itemList.forEach(function (items) {
                let EqualList = SelectList.filter(list => list.grp_cd === items.grp_cd && list.dtl_cd === items.dtl_cd);
                if (EqualList.length > 0) {
                    SelectState = EqualList;
                }
            });
            StyleGrp.push({ "contt": item[0], "Childlist": item[1], "SelectState": SelectState[0] });
        }
        if (StyleList.length === 0) {
            return false
        }
        else {
            return (
                <div className="Material_wrap">
                    {StyleGrp.map(list =>
                        <div className="category_slectbox" key={list.contt}>
                            <div className="title">{list.contt}</div>
                            {this.Stylerender(list.contt)}
                        </div>
                    )}
                </div>
            )
        }
    }

    Stylerender(contt) {
        let StyleList = this.state.StyleList.filter(list => list.contt === contt);
        let SelectList = this.state.StyleKeywordModel;

        if (StyleList.length === 0) {
            return false
        }
        else {
            return (
                <div className="category_select small_Category row row-cols-2">
                    {StyleList.map(list =>
                        <div className={SelectList.some(item => item.Sty_Cd === list.dtl_cd) ? "category_item col select" : "category_item col"}
                            key={list.dtl_cd}
                            onClick={(e) => this.handleStyleSelect_Click(e, list.dtl_cd, list.dtl_nm)}
                        >{list.dtl_nm}</div>    
                    )}
                </div>
            )
        }
    }
    
    render() {
        let Titlerender = this.Titlerender();
        return (
            <div className="modal fade" tabIndex="-1" id={this.props.id} data-bs-keyboard="false" data-bs-backdrop={this.props.backdrop === undefined ? "static" : this.props.backdrop} ref={this.StyleKeywordRef}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body style_select">
                            <button type="button" className="modal_in_close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal_title_v2">스타일 키워드등록</div>
                            <div className="input_txt">※ 최대 6개 중복선택 가능합니다.</div>
                                {Titlerender}
                            <div className="resister_button_box">
                                <button type="button" className="r_btn_v btn_inactive" onClick={this.handleClose_Click}>취소</button>
                                <button type="button" className="r_btn_v btn_v1" onClick={this.handleSave_Click}>등록</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
